module.exports = __webpack_public_path__ + "static/media/news-paper.5ba01e4d.svg";